import React from 'react';

export default function AppliedCouponBadge({coupon, discount, formatPrice, onRemove}) {
    const couponName = coupon?.data?.name || coupon?.code || '';
    const discountText = discount > 0 && typeof formatPrice === 'function'
        ? `-${formatPrice(discount)}`
        : '';

    return (
        <div className="resume-form__coupon-applied">
            <span className="resume-form__coupon-applied-label" title={couponName}>
                <span className="resume-form__coupon-applied-title">Promo code</span>
                <span className="resume-form__coupon-applied-code-row">
                    <strong>{couponName}</strong>
                    <button
                        type="button"
                        className="resume-form__coupon-remove"
                        onClick={onRemove}
                        aria-label="Remove coupon"
                    >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                             strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <polyline points="3 6 5 6 21 6"/>
                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                            <path d="M10 11v6"/>
                            <path d="M14 11v6"/>
                            <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/>
                        </svg>
                    </button>
                </span>
            </span>
            {discountText && (
                <span className="resume-form__coupon-applied-discount">{discountText}</span>
            )}
        </div>
    );
}
